module.exports = __webpack_public_path__ + "img/logo-placeholder.ca5c1d3b.png";